import { useApp } from '../../context/AppContext';

export function Confetti() {
  const { confetti } = useApp();
  
  if (!confetti) return null;
  
  const particles = Array.from({ length: 28 }, (_, i) => i);
  const colors = ["#4ade80", "#22c55e", "#86efac", "#fbbf24", "#a78bfa", "#60a5fa", "#f97316"];
  
  return (
    <div 
      style={{ 
        position: "fixed", 
        top: 0, 
        left: 0, 
        width: "100%", 
        height: "100%", 
        pointerEvents: "none", 
        zIndex: 9998, 
        overflow: "hidden" 
      }}
      aria-hidden="true"
    >
      <style>{`
        @keyframes confettiFall {
          0% { transform: translateY(-20px) rotate(0deg); opacity: 1; }
          100% { transform: translateY(100vh) rotate(720deg); opacity: 0; }
        }
      `}</style>
      {particles.map(i => (
        <div 
          key={i} 
          style={{
            position: "absolute",
            left: `${(i * 37) % 100}%`,
            top: `-${10 + (i * 13) % 30}px`,
            width: `${6 + (i * 3) % 8}px`,
            height: `${6 + (i * 5) % 8}px`,
            background: colors[i % colors.length],
            borderRadius: i % 3 === 0 ? "50%" : "2px",
            animation: `confettiFall ${1.4 + (i * 0.07) % 1}s ease-in ${(i * 0.04) % 0.6}s forwards`,
          }}
        />
      ))}
    </div>
  );
}
